/**
 * GALATEA SIGNATURE - DICIONÁRIO ESPANHOL BASE (Soberano)
 * Chaves e termos padrão em Espanhol.
 */

export const esBase = {
  common: {
    welcome: 'Bienvenido a Galatea Platform',
    dashboard: 'Panel de Control',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    search: 'Buscar',
    active: 'Activo',
    inactive: 'Inactivo',
    status: 'Estado',
    actions: 'Acciones',
    new: 'Nuevo',
    edit: 'Editar',
    filter: 'Filtrar',
    clear: 'Limpiar',
    export: 'Exportar',
    import: 'Importar',
    back: 'Volver',
    next: 'Siguiente',
    confirm: 'Confirmar',
    details: 'Detalles',
    menu: 'Menú Principal',
  },
  auth: {
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    accessPanel: 'Acceder al Panel',
    forgotPassword: '¿Olvidó su contraseña?',
    rememberMe: 'Recordarme',
  },
  entities: {
    title: 'Entidades',
    subtitle: 'Gestión de Clientes, Proveedores, Transportistas y Colaboradores',
    code: 'Código',
    document: 'Documento (RUT/CUIT/CPF/CNPJ)',
    name: 'Nombre / Razón Social',
    commercialName: 'Nombre Comercial / Fantasía',
    type: 'Tipo de Persona',
    physical: 'Física',
    legal: 'Jurídica',
    foreign: 'Extranjera',
    isClient: 'Es Cliente',
    isSupplier: 'Es Proveedor',
    isCarrier: 'Es Transportista',
    isEmployee: 'Es Colaborador / Vendedor',
    creditLimit: 'Límite de Crédito',
    address: 'Dirección',
    city: 'Ciudad',
    state: 'Estado / Departamento',
    country: 'País',
    zipCode: 'Código Postal',
    fiscal: 'Información Fiscal',
  },
  ai: {
    assistant: 'Galatea IA Asistente',
    query: 'Consulta Inteligente',
    audit: 'Auditoría y Diagnóstico Fiscal',
    startChat: 'Iniciar Consulta Inteligente',
  },
};

export default esBase;
